import { Landingpage } from "./landingpage";

export class Voucher {
    constructor(hasLogin) {
        this.inputCampaign = document.querySelector('#landingpage-voucher-campaign');
        this.inputCode = document.querySelector('#landingpage-voucher');
        this.submitButton = document.querySelector('#verifyVoucher');
        this.error = document.querySelector('.voucher-error');
        this.mode = 'voucherInactiv';
        this.ces = document.querySelectorAll('.loginBlock');
        this.loginButton = document.querySelector('#lpLoginButton');
        this.hasLogin = hasLogin;

        this.request = new Request('POST', '/verfiy/voucher');
        this.init();
    };

    init() {
        if(this.mode) {
            this.blockOrHide();
        }
       
        if( this.submitButton) {
            this.submitButton.addEventListener('click', event => {
                event.preventDefault();
                this.submitVoucher();
            });
        }

        let voucherCookie = Cookies.get('ovs_voucher') ?? false;
        if (voucherCookie) {
            this.inputCode.value = voucherCookie;
            this.submitVoucher();
        }
    };

    blockOrHide() {
        let block = false;
        this.ces.forEach(ce => {
            if(block) {
                ce.classList.add(this.mode);
            }
            if(ce.classList.contains('voucher')) {
                block = true;
            }
        });
    }

    unblock() {
        this.ces.forEach(ce => {
            ce.classList.remove(this.mode);
        });
    }

    submitVoucher() {
        this.request.data = {
            'voucher' : this.inputCode.value,
            'campaign' : this.inputCampaign.value,
            'productId' : Cookies.get('ovs_selected_offer'),
        };
        
        this.request.call(function(data) {
            if(data.status == 'ok') {
                this.unblock();
                this.error.classList.add('d-none');
                this.submitButton.innerHTML = "Einlösen";
                this.submitButton.disabled = true;
                this.inputCode.classList.remove('d-error');
                this.inputCode.classList.add('d-success');
                this.inputCode.setAttribute('readonly', 'readonly');

                if (this.hasLogin) {
                    window.Landingpage.login.blockOrHide();
                }
            } else {
                this.inputCode.classList.add('d-error');
                this.error.classList.remove('d-none');
                this.error.innerHTML = data.reason;
            }
        }.bind(this));
    }
}
